import { Route, Switch } from 'react-router-dom';
import { TicketListings } from '../containers/TicketListings';
import { TicketDetails } from '../containers/TicketDetails';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Routes() {
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "/",
      exact: true,
      component: TicketListings
    }), /*#__PURE__*/_jsx(Route, {
      path: "/ticket/:ticketId/:threadId?",
      component: TicketDetails
    })]
  });
}